// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__ZcYPK","additionalInfo":"AgreementModal_additionalInfo___ySt1"};